import styled from 'styled-components';
import { gridRow } from 'styleUtils/grid';

export const IconGridWrapper = styled.div`
    ${gridRow({ start: 2 })}
    margin-top: 1rem;
`;
